import WorkCard from './WorkCard';

export default WorkCard;
